<style lang="scss" scoped>
.age-consent-wrapper {
    display: none;
    position: fixed;
    width: 100vw;
    height: 100vh;
    top: 0;
    left: 0;
    background-color: rgba(24, 24, 40, 0.8);
    backdrop-filter: saturate(100%) blur(10px);
    z-index: 9999999;
    color: #fff !important;
    justify-content: center;

    &.active {
        display: flex;
    }

    p {
        max-width: 600px;
    }
}
</style>

<template>
    <div class="age-consent-wrapper p-24" :class="{active: this.active}">
        <div class="age-consent-inner flex flex-col justify-center align-middle text-center">
            <h2 class="fw-b mb-24 text-64" v-if="!declined"> {{translations.title}} </h2>
            <p class="mb-24 text-18 self-center" v-if="!declined" v-html="translations.description"></p>
            <p class="mb-24 text-18 self-center" v-if="declined" v-html="translations.description_declined"></p>
            <p class="mb-24 text-18 self-center" v-if="declined">{{countDown}}</p>
            <div class="flex flex-col items-center mb-40">
                <a @click="confirm" class="text-button rounded-button p-24 bg-blue mb-24 text-18 w-100 lg:w-50 cursor-pointer" v-if="!declined"> {{ translations.age_oke }} <span class="hvr-icon" v-html="svg('arrow-right', 'ml-16')"></span></a>
                <a @click="decline" class="text-button rounded-button p-24 border-white border-2 text-18 w-100 lg:w-50 cursor-pointer" v-if="!declined"> {{ translations.age_not_oke }}<span class="hvr-icon" v-html="svg('arrow-right', 'ml-16')"></span></a>
            </div>
            <div v-if="translations.warning" class="warning border border-white p-16 text-18">
                <strong v-html="translations.warning"></strong>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props:{
        translations: {
            type: Object,
            required: true,
        },
        locale: {
            type: String,
            required: true,
        },
    },
    data: () => ({
        active: false,
        declined: false,
        countDown: 10
    }),


    created() {
        if (Vue.$cookies.get('age-consent') == null || Vue.$cookies.get('age-consent-localisation') != this.locale ) {
            this.active = true;
        }
    },

    methods: {
        confirm() {
            Vue.$cookies.set('age-consent', true);
            Vue.$cookies.set('age-consent-localisation', this.locale);
            this.active = false;
        },

        decline() {
            this.declined = true;
            this.countDownTimer();
        },

        countDownTimer() {
            if (this.countDown > 0) {
                setTimeout(() => {
                    this.countDown -= 1
                    this.countDownTimer()
                }, 1000)
            } else {
                window.location.href = "https://www.google.be";
            }
        }
    }
}
</script>
